import React from 'react';
import { useDispatch } from 'react-redux';

import useSingleFileUpload from '@hooks/useSingleFileUpload';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

const UploadTrendResearchImage = ({ className, doFileSelection }) => {
	const { readFile } = useSingleFileUpload();
	const dispatch = useDispatch();

	const handleFileChange = async (e) => {
		const file = e.target.files?.[0];
		if (file) {
			dispatch(openLoader());
			const fileStr = await readFile(file);
			doFileSelection({
				name: file.name,
				docMimeType: file.type,
				documentType: 'TREND_RESEARCH_IMAGE_SEARCH_DATA',
				base64Str: fileStr
			});
			dispatch(closeLoader());
		}
	};

	return (
		<div className={className}>
			<label htmlFor="drag-upload" className="drag-upload" />
			<input
				type="file"
				id="drag-upload"
				className="file-upload"
				name="logo"
				onChange={handleFileChange}
			/>
		</div>
	);
};

export default UploadTrendResearchImage;
